import { render, staticRenderFns } from "./myorders.vue?vue&type=template&id=9d3fa89a&"
import script from "./myorders.vue?vue&type=script&lang=js&"
export * from "./myorders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports